import React, { useState, Fragment } from 'react';
import { StatusBadge } from '../components/StatusBadge';
import { ChevronDown, ChevronRight } from 'lucide-react';
export function SchedulerLogsPage() {
  const [statusFilter, setStatusFilter] = useState('All');
  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());
  // Mock Data
  const logs = [{
    id: 'SCH-20260214-01',
    date: '14 Feb 2026, 02:00 AM',
    type: 'Repayment Detection',
    status: 'Success',
    message: '3 overdue repayments processed'
  }, {
    id: 'SCH-20260214-02',
    date: '14 Feb 2026, 02:15 AM',
    type: 'Penalty Calculation',
    status: 'Failure',
    message: 'Connection timeout: Database unavailable during penalty batch processing. Retried 3 times.'
  }, {
    id: 'SCH-20260214-03',
    date: '14 Feb 2026, 03:00 AM',
    type: 'Overdue Marking',
    status: 'Success',
    message: '18 accounts marked as overdue'
  }, {
    id: 'SCH-20260213-01',
    date: '13 Feb 2026, 02:00 AM',
    type: 'Repayment Detection',
    status: 'Success',
    message: 'No new repayments found'
  }, {
    id: 'SCH-20260213-02',
    date: '13 Feb 2026, 02:15 AM',
    type: 'Penalty Calculation',
    status: 'Success',
    message: 'Calculated penalties for 5 accounts'
  }];
  const toggleRow = (id: string) => {
    const newExpanded = new Set(expandedRows);
    if (newExpanded.has(id)) {
      newExpanded.delete(id);
    } else {
      newExpanded.add(id);
    }
    setExpandedRows(newExpanded);
  };
  const filteredData = logs.filter(item => statusFilter === 'All' || item.status === statusFilter);
  return <div className="space-y-6" data-id="element-867">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-868">
        <div data-id="element-869">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-870">Scheduler Logs</h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-871">
            Monitor automated system jobs and execution status.
          </p>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm flex flex-col sm:flex-row gap-4 items-end" data-id="element-872">
        <div className="w-full sm:w-48" data-id="element-873">
          <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-874">
            Date
          </label>
          <input type="date" className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" data-id="element-875" />
        </div>

        <div className="w-full sm:w-48" data-id="element-876">
          <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-877">
            Status
          </label>
          <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm py-2 px-3 border" data-id="element-878">
            <option value="All" data-id="element-879">All</option>
            <option value="Success" data-id="element-880">Success</option>
            <option value="Failure" data-id="element-881">Failure</option>
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-lg overflow-hidden" data-id="element-882">
        <div className="overflow-x-auto" data-id="element-883">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-884">
            <thead className="bg-gray-50" data-id="element-885">
              <tr data-id="element-886">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-10" data-id="element-887"></th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-888">
                  Run ID
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-889">
                  Date & Time
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-890">
                  Job Type
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-891">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-892">
                  Message
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white" data-id="element-893">
              {filteredData.map(item => <Fragment key={item.id} data-id="element-894">
                  <tr className={`hover:bg-gray-50 transition-colors cursor-pointer ${expandedRows.has(item.id) ? 'bg-gray-50' : ''}`} onClick={() => toggleRow(item.id)} data-id="element-895">
                    <td className="px-6 py-4 whitespace-nowrap text-gray-400" data-id="element-896">
                      {expandedRows.has(item.id) ? <ChevronDown size={16} data-id="element-897" /> : <ChevronRight size={16} data-id="element-898" />}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-899">
                      {item.id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-900">
                      {item.date}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-901">
                      {item.type}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-902">
                      <StatusBadge status={item.status} data-id="element-903" />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 truncate max-w-xs" data-id="element-904">
                      {item.message}
                    </td>
                  </tr>
                  {expandedRows.has(item.id) && <tr className="bg-gray-50" data-id="element-905">
                      <td colSpan={6} className="px-6 py-4 text-sm text-gray-700 border-t border-gray-100 pl-16" data-id="element-906">
                        <div className="font-mono text-xs bg-gray-100 p-3 rounded border border-gray-200" data-id="element-907">
                          <strong data-id="element-908">Full Log:</strong> {item.message}
                          <br data-id="element-909" />
                          <span className="text-gray-500 mt-1 block" data-id="element-910">
                            Process ID: {Math.floor(Math.random() * 10000)}
                          </span>
                        </div>
                      </td>
                    </tr>}
                </Fragment>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}